<template>
    <div class="form-group">
        <span v-if="required" class="text-danger">*</span>
        <label :for="$attrs.id">
            {{label}}
        </label>
        <select class="form-control" v-if="!disabled" v-bind="$attrs" v-bind:value="value" @input="$emit('input', $event.target.value)" @change="$emit('change', $event.target.value)">
            <slot></slot>
        </select>
        <select class="form-control" v-else v-bind="$attrs" v-bind:value="value">
            <slot></slot>
        </select>
        <!--<span class="form-control" v-else>{{value}}</span>-->
    </div>
</template>

<script>
    export default {
        name: 'formSelect',
        inheritAttrs: false,
        props: ['value', 'label'],
        computed: {
            required: function () {
                return this.$attrs.required === "" || this.$attrs.required === true;
            },
            disabled: function () {
                return this.$attrs.disabled === "" || this.$attrs.disabled === true;
            }
        },
    };
</script>

<style>
</style>